<ng-container *transloco="let t">
  <div
    class="p-dialog-with-toolbar common-lookup-dialog lookup-dialog-content"
    [ngClass]="lookupId"
    [formGroup]="form"
    (keydown.enter)="applyFilters()"
  >
    <div class="grid condensed-row">
      <div class="col-12 filters">
        <p-accordion>
          <p-accordionTab header="{{ t('customer.customer_lookup_dialog.tabs.filters') }}" [selected]="true">
            <!-- first row -->
            <div class="p-fluid grid condensed-row">
              <div class="field md:col-3 sm:col-6 col-12">
                <input
                  zTextInput
                  zAutoFocus
                  formControlName="custid"
                  label="{{ t('customer.customer_lookup_dialog.filters.custid.label') }}"
                  placeholder="{{ t('customer.customer_lookup_dialog.filters.custid.placeholder') }}"
                  styleClass="w-full"
                  [uppercase]="true"
                  [clearButton]="true"
                  [matchTypes]="true"
                  (matchTypeChange)="onMatchTypeChange('custid', $event)"
                  defaultMatchType="startsWith"
                />
              </div>

              <div class="field md:col-3 sm:col-6 col-12">
                <input
                  zTextInput
                  formControlName="name"
                  label="{{ t('customer.customer_lookup_dialog.filters.name.label') }}"
                  placeholder="{{ t('customer.customer_lookup_dialog.filters.name.placeholder') }}"
                  styleClass="w-full"
                  [uppercase]="true"
                  [clearButton]="true"
                  [matchTypes]="true"
                  (matchTypeChange)="onMatchTypeChange('name', $event)"
                  defaultMatchType="startsWith"
                />
              </div>

              <div class="field md:col-6 col-12 flex justify-content-end align-self-end">
                <button
                  pButton
                  type="button"
                  icon="fad fa-check"
                  label="{{ t('customer.customer_lookup_dialog.filters.apply_filters') }}"
                  class="p-button-outlined"
                  (click)="applyFilters()"
                  style="width: auto"
                ></button>

                <button
                  pButton
                  type="button"
                  icon="fad fa-undo-alt"
                  label="{{ t('customer.customer_lookup_dialog.filters.reset') }}"
                  class="p-button-secondary p-button-outlined ml-2"
                  (click)="reset()"
                  style="width: auto"
                ></button>
              </div>
            </div>
          </p-accordionTab>
        </p-accordion>
      </div>

      <div class="col-12 grid-table overflow-hidden">
        <z-customer-lookup-dialog-grid></z-customer-lookup-dialog-grid>
      </div>
    </div>

    <div class="p-dialog-footer p-dialog-footer-toolbar">
      <p-toolbar styleClass="dialog-toolbar" [formGroup]="form">
        <div class="p-toolbar-group-left"></div>
        <div class="p-toolbar-group-right">
          <p-button
            label="{{ t('customer.customer_lookup_dialog.dialog.select') }}"
            styleClass="ml-1 p-button-primary"
            (click)="onSelectClick()"
          ></p-button>
          <p-button
            label="{{ t('customer.customer_lookup_dialog.dialog.cancel') }}"
            styleClass="ml-1 p-button-secondary"
            (click)="onCancelClick()"
          ></p-button>
        </div>
      </p-toolbar>
    </div>
  </div>
</ng-container>
